module.exports = __webpack_public_path__ + "static/page-e8078953e78ffe3d303759d4b230c301.png";